<template>
  <div class="side-bar-head">
    <div class="side-bar-head__item">Сотрудники</div>
    <div class="side-bar-head__item">Режим работы</div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style scoped lang="scss">
@use '../static/style/variables.scss' as *;
@use '../static/style/mixins.scss' as *;

.side-bar-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  border-radius: 0 3px 3px 0;
  height: 30px;
  background: #F4F4F4;
  border: 1px solid #CCCCCC;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    height: 150%;
    width: 1px;
    background: #CCCCCC;
    transform: rotate(326deg) translateX(-50%);
  }

  &__item {
    padding-left: 20px;
    width: 100%;
    font-weight: 500;
  }
}

</style>
